export const ErrorCodeMap: Record<number, string> = {
  10001: '未绑定手机号',
  10002: '无发帖权限',
  10003: '一小时内发帖频率限制',
  10004: '无操作权限',
  10005: '操作过于频繁',
  10021: '帖子状态异常',
  10022: '帖子审核中',
  10031: '上传数量/大小超限',
  10032: 'GIF图格式解析异常',
  10033: 'GIF图帧数超限',
  10041: '无创建标签权限',
  10050: '用户名称过长',
  10051: '用户名称已被占用',
  10052: '名称不在推荐列表中',
  10053: '用户名称审核失败（不符合社区规范）',
  10054: '用户名称过短',
  10060: '未查到此用户',
  10061: '未查到头像审核记录',
  10062: '头像审核中',
  10063: '头像审核失败（不符合社区规范）',
  10100: '搜索关键词不能为空',
  10101: '搜索页码参数无效',
  10102: '搜索每页条数参数无效',
  10103: '服务繁忙，请稍后重试',
  10200: '设备列表查询结果为空',
  10201: '请求参数为空',
  10202: '设备Key为空',
  10203: '设备名称为空',
  10204: '设备标签名称为空',
  10205: '设备类型为空',
  10206: '设备官网链接为空',
  10207: '设备图片为空',
  10208: '设备标签名称已存在',
  10209: '创建后未找到对应标签',
  10210: '设备更新ID为空',
  10211: '设备不存在',
  10212: '设备删除ID为空',
  10213: '频道规则标签无效',
  10214: '禁止修改的设备字段',
  10215: '官网链接格式错误',
  10216: '图片链接格式错误',
  10220: '请求中设备分类名称重复',
  10221: '设备分类名称已存在',
  10222: '设备分类更新ID为空',
  10223: '设备分类不存在',
  10224: '设备分类删除ID为空',
  10225: '删除失败：该分类下存在子分类',
  10226: '删除失败：该分类下存在关联设备',
  10227: '操作类型为空',
  10228: '设备分类名称为空',
  10230: '名称格式错误（包含非法字符）',
  10231: '名称长度超限',
  10232: '一级设备分类名称已存在',
  10233: '二级设备分类名称已存在',
  10234: 'Key格式无效',
  10235: '圈子参数无效',
  10236: '主题参数无效',
  20000: '系统繁忙，请稍后再试',
  20001: '系统繁忙，请稍后再试',
  30001: '资源上传失败',
  30002: '资源审核失败',
  30003: '生成临时签名url失败',
};

export function getErrorMessage(code: number): string {
  return ErrorCodeMap[code] ?? `未知错误（${code}）`;
}
